var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./CourierRates.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2a2d698c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CourierRates.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RateAndBugs/CourierRates.vue
// module id = 409
// module chunks = 1